module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAnklEQVQoU5WQ4QnCMBCF7zVJRVB0BEeoE+hC2jqJrS6kE5gROoKiILZJThKpWOiPeP/u+ODd90CRg4577mlhhcoJSRZu7LSwbTXeUe3XAHrIiPQCYP4bwMxXaZulhwP4OKqSKMmHv3DVZNMWAbwfRieAVkMgM52n29f6PzA6OsjIVIMw68kQ36Rpsq9MZ26lKpg/9QBOC9OWvXpiOn8DSWxEC/KU5EYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/point.png
// module id = J1r2
// module chunks = 1